import { Component, OnInit } from '@angular/core';
import { UtilsService } from 'src/app/utils/utils.service';
import { DroughtMapConstants } from './drought-dashboard-gis/drought-dashboard-map.constant';
import { UtilsSharedModule } from '../../shared/utils/utils/utils.module';
import { Router, ActivatedRoute } from '@angular/router';
import * as moment from 'moment';


@Component({
  selector: 'app-drought-dashboard',
  templateUrl: './drought-dashboard.component.html',
  styleUrls: ['./drought-dashboard.component.scss']
})
export class DroughtDashboardComponent implements OnInit {
  selected:any = "Mandatory Parameters";  //for def selection
  maxDate: any;
  minDate: Date;
  weekNo : any;
  dateList = [];
  paramters = {};
  categoryList : any = [];
  layerGroupList = {};
  finalGroupList = [];
  format = {value: 'yyyyMMdd'}
  eventGenDate: object = { required: true };
  subGroupSelected = "RF Deviation"  //for final selection of category
  validation: boolean[] = new Array(5).fill(true);
  showParams = false;
  constructor(private utils : UtilsService,private utilsShared : UtilsSharedModule,private router: Router) { }

  ngOnInit() {
    const startEndList = this.getstartandEndForNday(5);
    const DateString = this.getCurrentDateInString()

    this.dateList = [
      // { key: '01-August-2018', val: 20180801 },
      // { key: '31-August-2018', val: 20180831 },
      // { key: '01-August-2019', val: 20190801 },
      // { key: '31-August-2019', val: 20190831 },
      // { key: '01-August-2020', val: 20200801 },
      // { key: '31-August-2020', val: 20200831 },
      // { key: '01-August-2021', val: 20210801 },
      // { key: '31-August-2021', val: 20210831 },
      // { key: '31-July-2022', val: 20220731 },
      // { key: '01-August-2022', val: 20220801 },
      { key: '31-August-2022', val: 20220831 },
      // { key: '01-August-2023', val: 20230801 },
      { key: DateString, val: startEndList[1] },

    ]
    this.maxDate = new Date()
    this.categoryList = [3,4];
    this.getParams();
    // this.setLayerControlData();
    this.layerGroupList = DroughtMapConstants.DroughtControlLayers;
    this.utils.getQueryParamsDrought().subscribe(value =>{
      // console.log(value)
      if(!value || Object.keys(value).length == 0){
        this.weekNo = "3",
        this.eventGenDate['value'] = startEndList[1] ;
        // this.eventGenDate['value'] =  this.utilsShared.getDateObjectFromModelDate("20190831");
      } else {
        this.weekNo = value['weekNo'],
        this.eventGenDate['value'] = parseInt(value['eventGenDate'])
        // this.eventGenDate['value'] =  this.utilsShared.getDateObjectFromModelDate((value['eventGenDate']).toString());
      }
    })
  }
  getstartandEndForNday(nday) {
    let startDate, endDate;
    const startandEndList = [];
    const currentDate = new Date();
    const currentTs = new Date().setHours(0, 0, 0, 0);
    const rfStartofDay = currentTs + 8.5 * 3600 * 1000;
    if (currentDate.getTime() >= rfStartofDay) {
      endDate = moment().format('YYYYMMDD');
      startDate = moment().subtract(nday - 1, 'days').format('YYYYMMDD');
    } else {
      endDate = moment().subtract(1, 'days').format('YYYYMMDD');
      startDate = moment().subtract(nday, 'days').format('YYYYMMDD');
    }
    startandEndList[0] = startDate;
    startandEndList[1] = endDate;
    return startandEndList;
  }
  getCurrentDateInString(){
    let date = new Date;
    let month = date.getMonth();
    let year = date.getFullYear()
    let day = date.getDate();
    const monthNames = ["January", "February", "March", "April", "May", "June",
  "July", "August", "September", "October", "November", "December"
];
  let currDate
    if(day<10){
      currDate = '0'+day + '-' + monthNames[month] + '-' + year

    }
    else{
      currDate = day + '-' + monthNames[month] + '-' + year

    }
    // console.log("@@",currDate)
    return currDate
  }
  getParams(){
    return this.utils.getQueryParamsDroughtValue();
  }
  submit(){
    // console.log(parseInt(this.eventGenDate['value']))
    this.paramters = this.getParams();
    if(Object.keys(this.paramters).length == 0){
      this.paramters['componentType'] = "RF_DEVIATION"
    }
    this.paramters['weekNo'] = parseInt(this.weekNo);
    this.paramters['eventGenDate'] = parseInt(this.eventGenDate['value'])
    // this.paramters['eventGenDate'] = parseInt(this.utilsShared.getModelDateWithDateFormat(this.eventGenDate['value'], this.format['value']))
    this.paramters['maponclick'] = false;
    this.utils.setQueryParamsDrought(this.paramters);
  }
  updateComponentType(component_type){
    let currDate = this.getstartandEndForNday(5)
    this.paramters = this.getParams();
    if(Object.keys(this.paramters).length == 0){
      this.paramters['weekNo'] = "3",
      this.paramters['eventGenDate'] = currDate[1];
      // this.paramters['eventGenDate'] = "20190831";
    }
    this.paramters['componentType'] = component_type;
    this.paramters['maponclick'] = false;
    // console.log(this.paramters)
    this.utils.setQueryParamsDrought(this.paramters);
  }
  setLayerControlData() {
    Object.keys(DroughtMapConstants.DroughtControlLayers).forEach((index) =>{
      // console.log(DroughtMapConstants.DroughtControlLayers[index])
      if (
        DroughtMapConstants.DroughtControlLayers[index].group &&
        !this.layerGroupList[DroughtMapConstants.DroughtControlLayers[index].group] &&
        DroughtMapConstants.DroughtControlLayers[index].showOnSelector != false
      ) {
        this.layerGroupList[DroughtMapConstants.DroughtControlLayers[index].group] = {};
        this.layerGroupList[DroughtMapConstants.DroughtControlLayers[index].group]["show"] = false;
        this.layerGroupList[DroughtMapConstants.DroughtControlLayers[index].group]["groupType"] = DroughtMapConstants.DroughtControlLayers[index].groupType;
        this.layerGroupList[DroughtMapConstants.DroughtControlLayers[index].group]["subgroup"] = {};
      }
      if(DroughtMapConstants.DroughtControlLayers[index].group && DroughtMapConstants.DroughtControlLayers[index].custom){
        this.layerGroupList[DroughtMapConstants.DroughtControlLayers[index].group]["custom"] = true;
      }
      if (
        DroughtMapConstants.DroughtControlLayers[index].subgroup &&
        !this.layerGroupList[DroughtMapConstants.DroughtControlLayers[index].group]["subgroup"][DroughtMapConstants.DroughtControlLayers[index].subgroup] &&
        this.layerGroupList[DroughtMapConstants.DroughtControlLayers[index].group]
      ) {
        this.layerGroupList[DroughtMapConstants.DroughtControlLayers[index].group]["subgroup"][DroughtMapConstants.DroughtControlLayers[index].subgroup] = {};
        this.layerGroupList[DroughtMapConstants.DroughtControlLayers[index].group]["subgroup"][
          DroughtMapConstants.DroughtControlLayers[index].subgroup
        ]["show"] = false;
        this.layerGroupList[DroughtMapConstants.DroughtControlLayers[index].group]["subgroup"][DroughtMapConstants.DroughtControlLayers[index].subgroup]["groupType"] = DroughtMapConstants.DroughtControlLayers[index].groupType;
      }
      //if (DroughtMapConstants.DroughtControlLayers[index].showOnSelector != false)
      //  layerControlLayers[index] = DroughtMapConstants.DroughtControlLayers[index];
      // console.log(this.layerGroupList)
    })
    //angular.forEach(layers.overlaylayers, function (value, key) {
      // if (
      //   value.options.group &&
      //   !this.layerGroupList[value.options.group] &&
      //   value.options.showOnSelector != false
      // ) {
      //   layerGroupList[value.options.group] = {};
      //   layerGroupList[value.options.group]["show"] = false;
      //   layerGroupList[value.options.group]["groupType"] = value.options.groupType;
      //   layerGroupList[value.options.group]["subgroup"] = {};
      // }
      // if(value.options.group && value.options.custom){
      //   layerGroupList[value.options.group]["custom"] = true;
      // }
      // if (
      //   value.options.subgroup &&
      //   !layerGroupList[value.options.group]["subgroup"][value.options.subgroup] &&
      //   layerGroupList[value.options.group]
      // ) {
      //   layerGroupList[value.options.group]["subgroup"][value.options.subgroup] = {};
      //   layerGroupList[value.options.group]["subgroup"][
      //     value.options.subgroup
      //   ]["show"] = false;
      //   layerGroupList[value.options.group]["subgroup"][value.options.subgroup]["groupType"] = value.options.groupType;
      // }
      // if (value.options.showOnSelector != false)
      //   layerControlLayers[key] = value;
   // });
  }

  getDeviceType(){
    return this.utils.getDeviceType();
  }

  closePopup(){
    this.showParams = false;
  }

}
